const topics = [
  { name: '#顶流恋情', hot: true, count: '128K' },
  { name: '#综艺翻车', hot: true, count: '96K' },
  { name: '#饭圈大战', hot: false, count: '87K' },
  { name: '#影视爆料', hot: true, count: '75K' },
  { name: '#明星翻车', hot: false, count: '68K' },
  { name: '#直播事故', hot: false, count: '55K' },
  { name: '#资本暗战', hot: true, count: '52K' },
  { name: '#时尚红毯', hot: false, count: '41K' },
  { name: '#海外八卦', hot: false, count: '38K' },
  { name: '#独家内幕', hot: true, count: '33K' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
          当前最受吃瓜群众关注的话题标签
        </p>
        <div className="flex flex-wrap justify-center gap-2.5 md:gap-3 max-w-4xl mx-auto">
          {topics.map((item, idx) => (
            <a
              key={idx}
              href={`#carousel`}
              className={`inline-flex items-center gap-2 px-3.5 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer border ${
                item.hot
                  ? 'bg-primary-50 text-primary-700 border-primary-200 hover:bg-primary-100'
                  : 'bg-background-100 text-foreground-600 border-background-200 hover:border-primary-200 hover:text-primary-600'
              }`}
            >
              {item.name}
              <span className={`text-xs ${item.hot ? 'text-primary-500' : 'text-foreground-400'}`}>
                {item.count}
              </span>
              {item.hot && (
                <i className="ri-fire-line text-accent-500 text-xs"></i>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}